import { render, staticRenderFns } from "./CreateConfigModal.vue?vue&type=template&id=15455d4b&scoped=true"
import script from "./CreateConfigModal.vue?vue&type=script&lang=ts"
export * from "./CreateConfigModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15455d4b",
  null
  
)

export default component.exports